// Ключи localStorage для режима входа из админки в пользователя (impersonation).
// Ставятся на странице /admin-login-to-client, читаются в UserMenu для показа
// кнопки «Back to admin». Очищаются при выходе (logout) и при возврате в админку.
export const IMPERSONATION_FLAG_KEY = "isImpersonating";
export const ADMIN_RETURN_URL_KEY = "adminReturnUrl";
